module.exports = __webpack_public_path__ + "img/scoreboard_alt.15641e8e.png";